import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, Select2Data, getDimension, IMG_URL } =
    useContext(Context);
  const [countries, setCountries] = useState([]);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/cabs/${id}`);
    reset(response?.data);
  };

  const GetAllCategory = async () => {
    const response = await getData("/all-cab-type-mobile");

    if (response?.success) {
      setCountries(await Select2Data(response?.data, "cab_type_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
  }, []);

  useEffect(() => {
    // GetAllCategory();
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
    setValue,
    watch,
    getValues,
  } = useForm();


  const imageFile = watch("image");
  const onSubmit = async (data) => {
    try {
        const langPayload = countLang.map((lang) => ({
        language_id: lang.id,
        name: data[lang.id],
      }));

      const formData = new FormData();

      formData.append(
        "cab_type_id",
        data.cab_type_id?.value || data.cab_type_id
      );
     

      // Append languages array as JSON string
      formData.append("languages", JSON.stringify(langPayload));

      const response = await postData(`/masters/cabs/${id}`, formData);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };
const [countLang, setCountLang] = useState([]);

  const getLanguges = async () => {
    const response = await getData("/all-languages");
    setCountLang(response.data);
  };

  useEffect(() => {
    getLanguges();
  }, []);
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Cabs
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Cab Type</Form.Label>
                    <Controller
                      name="cab_type_id" // name of the field
                      {...register("cab_type_id", {
                        required: "Select Cab type",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.cab_type_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={countries}
                        />
                      )}
                    />
                    {errors.cab_type_id && (
                      <span className="text-danger">
                        {errors.cab_type_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              {countLang?.map((lang, index) => (
                <Col md={12} key={lang.id}>
                  <div className="main-form-section mt-5">
                    <Row className="justify-content-center">
                      <Form.Label column sm={3}>
                        Cab Name ({lang?.name})
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control
                              type="text"
                              placeholder={`Enter Cab Name in ${lang?.name}`}
                              className="input-mandatory"
                              {...register(`${lang.id}`, {
                                required: `Cab Name is required in ${lang.name}`,
                              })}
                            />
                          </InputGroup>
                          {errors[lang.id] && (
                            <span className="text-danger">
                              {errors[lang.id].message}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}

            
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
